<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="propertyName"
      [canGoBack]="!windowService.isDesktopRes" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {
      <tidy-card>
        <tidy-row>
          <tidy-text [header]="'Noise Levels (30 days)'" />
        </tidy-row>
        <tidy-lazy-chart
          [series]="chartSeries"
          [chart]="chartOptions"
          [xaxis]="chartXaxis"
          [yaxis]="chartYaxis"
          [stroke]="chartStroke"
          [grid]="chartGrid"
          [tooltip]="chartTooltip"
          style="margin-top: 12px; display: block;" />
      </tidy-card>

      <tidy-row class="extra-top-padding">
        <tidy-text [header]="'Noise Anomalies'" />
      </tidy-row>

      @for (anomaly of anomalies; track anomaly.id) {
        <tidy-card>
          <tidy-row [alignLastItemRight]="true">
            <tidy-text [title]="anomaly.dateFormatted + (' at ' | translate) + anomaly.timeFormatted" />
            <tidy-text
              [title]="anomaly.statusLabel"
              [ngStyle]="{ color: anomaly.statusColor }" />
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="anomaly.noiseLevel + (' dB peak — lasted ' | translate) + anomaly.duration" />
          </tidy-row>

          @if (anomaly.notes.length) {
            <tidy-divider />
            @for (note of anomaly.notes; track note.id) {
              <tidy-row class="extra-top-padding">
                <div>
                  <tidy-text [body]="note.text" />
                  <tidy-text
                    [helper]="note.createdBy + ' · ' + (note.createdAt | date:'MMM d, h:mm a')" />
                </div>
              </tidy-row>
            }
          }

          <tidy-divider />
          <tidy-row class="extra-top-padding">
            <form [formGroup]="anomaly.noteForm" novalidate action="#" style="width: 100%;">
              <tidy-row [align]="'center'">
                <tidy-input
                  formControlName="note"
                  [form]="anomaly.noteForm.controls.note"
                  [label]="'Add a note...'"
                  [icon]="'assets/svg/create-outline.svg'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [actionBody]="'Save Note'"
                  (action)="addNote(anomaly)"
                  class="link" />
              </tidy-row>
            </form>
          </tidy-row>
        </tidy-card>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
